// Pointer
// Features:
// - Logic-only component (renderless)
// - Syncs "crosshairOn" state based on interaction + pointer lock
// - Keeps crosshair logic centralized and decoupled from the visual component

import { useEffect } from 'react'
import { useStore } from '../store/useStore'

export default function Pointer() {
    const currentHitName = useStore((s) => s.currentHitName)
    const isPointerLocked = useStore((s) => s.isPointerLocked)

    useEffect(() => {
        // Enable crosshair only when looking at an interactive object AND pointer is locked
        const shouldShow = Boolean(currentHitName) && Boolean(isPointerLocked)
        useStore.getState().setCrosshairOn(shouldShow)
    }, [currentHitName, isPointerLocked])

    return null
}
